import React from "react"
import { motion } from "framer-motion"

const LOG = [
  {
    time: "MAR 2025",
    sub: "— PRESENT",
    current: true,
    role: "L1 Support Associate Team Leader",
    org: "Mahavir Shree International Pvt. Ltd — Kathmandu",
    bullets: [
      "Configured and maintained CUPPS and BRS systems at the airport, including static IPs and printer setups for boarding pass, baggage tag and DCP printers.",
      "Handled system imaging and deployment for efficient software updates.",
      "Provided IT support to resolve hardware and software issues and keep performance stable.",
    ],
  },
  {
    time: "AUG 2024",
    sub: "— DEC 2024",
    role: "Backend Developer",
    org: "Tonic Byte Pvt. Ltd. — Pokhara",
    bullets: [
      "Developed and maintained backend APIs using JavaScript, TypeScript, Node.js and Express.",
      "Designed and managed databases with PostgreSQL and Prisma ORM.",
      "Implemented API integrations, including OneSignal, for scalable and secure server-side functionality.",
    ],
  },
  {
    time: "OCT 2023",
    sub: "— JAN 2024",
    role: "Network and System Administrator Intern",
    org: "Informatics College Pokhara — Pokhara",
    bullets: [
      "Assisted in maintaining campus networks, servers and workstations.",
      "Performed routine updates and configurations.",
      "Supported staff and students with troubleshooting to keep IT operations stable.",
    ],
  },
  {
    time: "2023",
    role: "Volunteer, Futurama / ICP",
    org: "ING Skill Academy",
    bullets: [],
  },
  {
    time: "—",
    role: "Nepali Audio Transcription",
    org: "Thoth AI — transcription for AI model training",
    bullets: [],
  },
]

export default function Experience() {
  return (
    <section id="experience" className="bg-ink text-white border-t border-lineSoft py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-baseline gap-3.5 mb-10">
          <span className="font-mono text-xs text-amber">02</span>
          <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">Experience log</h2>
        </div>

        <div>
          {LOG.map((item, i) => (
            <motion.div
              key={item.role}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className={`grid grid-cols-1 sm:grid-cols-[150px_1fr] gap-2 sm:gap-6 py-7 ${
                i !== 0 ? "border-t border-lineSoft" : ""
              }`}
            >
              <div className="font-mono text-xs text-muted2 pt-0.5">
                {item.time}
                {item.sub && (
                  <>
                    <br />
                    <span className={item.current ? "text-mint" : ""}>{item.sub}</span>
                  </>
                )}
              </div>
              <div>
                <div className="font-display font-semibold text-lg">{item.role}</div>
                <div className="font-mono text-xs text-amber mt-1 mb-3">{item.org}</div>
                {item.bullets.length > 0 && (
                  <ul className="space-y-1.5">
                    {item.bullets.map((b) => (
                      <li key={b} className="text-muted text-sm pl-4 relative">
                        <span className="text-amber absolute left-0">›</span>
                        {b}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
